var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewspaper({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.5,0H7.5c-1.378,0-2.5,1.122-2.5,2.5v4.5H0v14c0,1.654,1.346,3,3,3h18c1.654,0,3-1.346,3-3V2.5c0-1.378-1.122-2.5-2.5-2.5ZM5,21c0,1.103-.897,2-2,2s-2-.897-2-2v-13h4v13Zm18,0c0,1.103-.897,2-2,2H5.234c.476-.531.766-1.232.766-2V2.5c0-.827.673-1.5,1.5-1.5h14c.827,0,1.5.673,1.5,1.5v18.5ZM15,7h6v1h-6v-1Zm-7,4h13v1h-13v-1Zm0,4h13v1h-13v-1Zm0,4h13v1h-13v-1ZM13,3h-5v5h5V3Zm-1,4h-3v-3h3v3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.61542109f1e3da7641a9a5809fb20966.svg";
export { ForwardRef as ReactComponent };